import { render, staticRenderFns } from "./factoryManage.vue?vue&type=template&id=27ca7dd2&scoped=true"
import script from "./factoryManage.vue?vue&type=script&lang=js"
export * from "./factoryManage.vue?vue&type=script&lang=js"
import style0 from "./factoryManage.vue?vue&type=style&index=0&id=27ca7dd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca7dd2",
  null
  
)

export default component.exports